import { render, staticRenderFns } from "./NewMessenger.vue?vue&type=template&id=219cce30&scoped=true"
import script from "./NewMessenger.vue?vue&type=script&lang=js"
export * from "./NewMessenger.vue?vue&type=script&lang=js"
import style0 from "./NewMessenger.vue?vue&type=style&index=0&id=219cce30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219cce30",
  null
  
)

export default component.exports